import(/* webpackMode: "eager" */ "/build/apps/web/src/app/not-found.tsx");
